export default __webpack_public_path__ + "20d939ff292f273e709c9c074e71590c.svg";